import React from "react";

import { Header } from "../../internal/Header/Header";

const Index = ({ children }) => {
  return (
    <Header showSidebar selectedItem="my_parties">
      {children}
    </Header>
  );
};

export default Index;
